var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Italic = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [_jsx("title", { children: "italic" }), _jsx("path", { d: "M7.9989 19.1998V18.9324C8.82176 18.9324 9.41833 18.5415 9.70633 17.1427L11.8869 6.85695C12.1749 5.45809 11.5578 5.06723 10.7143 5.06723V4.7998H16.0012V5.06723C15.1578 5.06723 14.5612 5.45809 14.2732 6.85695L12.1132 17.1427C11.8252 18.5415 12.4423 18.9324 13.2652 18.9324V19.1998H7.9989Z", fill: fill !== null && fill !== void 0 ? fill : COLORS.PURPLE[900] })] })));
};
